import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import PatientFeedingTable from "./PatientFeedingTable";
import { useParams } from "react-router-dom";
import PatientTrainingTable from "./PatientTrainingTable";
import PatientBreathingTable from "./PatientBreathingTable";
import DashServices from "../../services/DashServices";
import UserServices from "../../services/UserServices";
import PatientNotepadTable from "./PatientNotepadTable";
import PatientPhysicalActivityTable from "./PatientPhysicalActivityTable";
import PatientWaterTable from "./PatientWaterTable";

const PatientLogBook = () => {
  const { username } = useParams();
  const [modules, setModules] = useState([]);
  const expectedModules = [
    { name: "Alimentacion", label: "Alimentación" },
    { name: "Agua", label: "Carga de agua" },
    { name: "Ejercitación", label: "Ejercitación" },
    { name: "manual_physical_activity", label: "Actividad física" },
    { name: "Respiración", label: "Respiración" },
    { name: "notepad", label: "Block de notas" },
  ];
  const [feedingSubmodules, setFeedingSubmodules] = useState([]);
  const [activeKey, setActiveKey] = useState("Alimentacion");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await UserServices.getPatientInfo(username);

        if (response.status >= 200 && response.status < 300) {
          loadSubscription(
            response.data.patient_info.map((i) => i.subscription.id)
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const loadSubscription = async (ids) => {
    try {
      const fetchPromises = ids.map((i) => DashServices.getSubscriptions(i));

      const res = await Promise.all(fetchPromises);
      const arrayModules = [];
      let selectedIndex = 100;
      await Promise.all(
        res.map((r) => {
          if (r.status != 200) return;

          for (module of r.data.subscription.modules) {
            // Check if this module has a lower index in expectedModules than the current activeKey
            const currentIndex = expectedModules.findIndex(
              (expectedModule) => expectedModule.name === module.name
            );
            if (currentIndex !== -1) {
              if (currentIndex < selectedIndex) {
                selectedIndex = currentIndex;
                setActiveKey(expectedModules[selectedIndex].name);
              }
            }
            if (module.name === "Alimentacion") {
              setFeedingSubmodules(module.submodules);
            }
            arrayModules.push(module.name);
          }
        })
      );
      setModules(arrayModules);
    } catch (error) {
      console.error(error);
    }
  };

  const getItems = () => {
    const items = [];
    expectedModules.forEach((module, index) => {
      const disabled = !modules.includes(module.name);

      items.push({
        label: module.label,
        key: module.name,
        disabled: disabled,
        children: (
          <>
            {module.name === "Alimentacion" && !disabled && (
              <PatientFeedingTable feedingSubmodules={feedingSubmodules} />
            )}
            {module.name === "Agua" && !disabled && <PatientWaterTable />}
            {module.name === "Ejercitación" && !disabled && (
              <PatientTrainingTable />
            )}
            {module.name === "manual_physical_activity" && !disabled && (
              <PatientPhysicalActivityTable />
            )}
            {module.name === "Respiración" && !disabled && (
              <PatientBreathingTable />
            )}
            {module.name === "notepad" && !disabled && <PatientNotepadTable />}
          </>
        ),
      });
    });
    return items;
  };

  return (
    <Tabs
      defaultActiveKey="Alimentacion"
      activeKey={activeKey}
      items={getItems()}
      onTabClick={(key) => setActiveKey(key)}
    />
  );
};

export default PatientLogBook;
